// extracted by mini-css-extract-plugin
module.exports = {"header":"ShipmentList_header__G59IB","title":"ShipmentList_title__2YyFv","small":"ShipmentList_small__ADFhN","btnContainer":"ShipmentList_btnContainer__vba94"};